import styled from "styled-components";
import {
  NO_CONTENT_GRAPHIC_TOP_MARGIN_MOBILE,
  NO_CONTENT_GRAPHIC_TOP_MARGIN_TABLET,
} from "styles/global-styles";
import { tablet } from "styles/breakpoints";

export const ComingSoonIconContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  margin-top: ${NO_CONTENT_GRAPHIC_TOP_MARGIN_MOBILE}px;

  svg {
    width: 175px;
    height: 210px;
  }

  && {
    p {
      opacity: 0.85;
      color: #4a4d5e;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
  }

  @media (min-width: ${tablet}px) {
    margin-top: ${NO_CONTENT_GRAPHIC_TOP_MARGIN_TABLET}px;

    svg {
      width: 300px;
      height: 352px;
    }

    && {
      p {
        font-size: 24px;
      }
    }
  }
`;
